export default __webpack_public_path__ + "static/bcorp-fc20b562c751f232f68ad06f3150ccc1.svg";